export default __webpack_public_path__ + "static/media/babaunited.7b38c613.jpg";